import { createAction, props } from '@ngrx/store';
import { BankAccount } from './../../interfaces';

enum BankAccountActionIds {
    loadBankAccount = '[Bank Account] Load Bank Account',
    setBankAccount = '[Bank Account] Set Bank Account',
    setBankAccountName = '[Bank Account] Set Bank Account Name',
    setBankAccountType = '[Bank Account] Set Bank Account Type',
    setBankCity = '[Bank Account] Set Bank City',
    setBankName = '[Bank Account] Set Bank Name',
    setBankState = '[Bank Account] Set Bank State',
    setRoutingNumber = '[Bank Account] Set Routing Number',
    resetBankAccount = '[Bank Account] Reset Bank Account',
}

export const LoadBankAccountAction = createAction(
    BankAccountActionIds.loadBankAccount
);

export const SetBankAccountAction = createAction(
    BankAccountActionIds.setBankAccount,
    props<BankAccount>()
);

export const SetBankAccountNameAction = createAction(
    BankAccountActionIds.setBankAccountName,
    props<{ bankAccountName: string }>()
);

export const SetBankAccountTypeAction = createAction(
    BankAccountActionIds.setBankAccountType,
    props<{ bankAccountType: string }>()
);

export const SetBankCityAction = createAction(
    BankAccountActionIds.setBankCity,
    props<{ bankCity: string }>()
);

export const SetBankNameAction = createAction(
    BankAccountActionIds.setBankName,
    props<{ bankName: string }>()
);

export const SetBankStateAction = createAction(
    BankAccountActionIds.setBankState,
    props<{ bankState: string }>()
);

export const SetRoutingNumberAction = createAction(
    BankAccountActionIds.setRoutingNumber,
    props<{ routingNumber: string }>()
);

export const ResetBankAccountAction = createAction(
    BankAccountActionIds.resetBankAccount
);